import React from "react";

import {
  Button,
  CompassColor,
  Spacing,
  Stack,
} from "@noom/wax-component-library";

import { QuestionOption } from "@/components/survey/Question";

type MultipleChoiceOptionsProps = {
  onClick: (optionId: string) => void;
  options: QuestionOption[];
  selectedItem?: string;
};

export const MultipleChoiceOptions: React.FC<MultipleChoiceOptionsProps> = ({
  onClick,
  options,
  selectedItem,
}) => (
  <Stack spacing={Spacing[4]}>
    {options.map((option) => {
      const selected = option.id === selectedItem;

      return (
        <Button
          key={option.id}
          size="xl"
          onClick={() => onClick(option.id)}
          backgroundColor={selected ? CompassColor.lagoon : CompassColor.offWhite}
          border={`2px solid ${selected ? CompassColor.lagoon : CompassColor.offWhite}`}
          borderRadius="8px"
          color={selected ? CompassColor.white : CompassColor.black}
          fontWeight="normal"
          height="60px"
          whiteSpace="normal"
          width="100%"
          maxWidth="100%"
          wordBreak="break-word"
          overflowWrap="break-word"
          _hover={{
            backgroundColor: selected ? CompassColor.lagoon : CompassColor.sand02,
            border: `2px solid ${selected ? CompassColor.lagoon : CompassColor.sand02}`,
          }}
        >
          {option.text}
        </Button>
      );
    })}
  </Stack>
);
